import { render, staticRenderFns } from "./TaxReceiptInformation.vue?vue&type=template&id=0fc29585"
import script from "./TaxReceiptInformation.vue?vue&type=script&lang=js"
export * from "./TaxReceiptInformation.vue?vue&type=script&lang=js"
import style0 from "./TaxReceiptInformation.vue?vue&type=style&index=0&id=0fc29585&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports